<template>
  <v-card>
    <v-card-title>
      <span class="headline" v-translate>Forgot Password</span>
    </v-card-title>
    <div class="pl-4"><ErrorMessages :error="error" /></div>
    <v-card-text class="px-4 py-1">
      <v-form ref="form">
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              label="E-mail *"
              placeholder=" "
              v-model="email"
              :rules="[
                (v) => !!v || 'This field is required',
                (v) =>
                  /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                  'This is not valid email',
              ]"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="closeDialog">
        <translate>Close</translate>
      </v-btn>
      <v-btn color="blue darken-1" text @click.prevent="forgotPassword" :loading="loading">
        <translate>Reset Password</translate>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate'
// import { required, email } from 'vuelidate/lib/validators'
import { Auth } from 'aws-amplify'
export default {
  name: 'ForgotPassword',

  mixins: [validationMixin],

  props: {
    closeDialog: {
      type: Function,
      required: true,
    },
    dialog: {
      type: Boolean,
      required: true,
    },
  },

  watch: {
    dialog(newValue) {
      if (!newValue) {
        this.$refs.form.reset()
        this.error = ''
      }
    },
  },

  data() {
    return {
      error: '',
      email: '',
      loading: false,
    }
  },

  methods: {
    forgotPassword() {
      this.error = ''

      if (!this.$refs.form.validate()) return
      this.loading = true
      Auth.forgotPassword(this.email)
        .then(() => {
          this.loading = false
          this.$store.commit('openSnackBar', {
            text: `The code has been sent`,
            color: 'success',
          })
          this.closeDialog()
          this.$router.push({ path: '/confirm-forgot-password' })
        })
        .catch((err) => {
          console.error(err)
          this.loading = false
          this.error = err.message
        })
    },
  },
}
</script>

<style lang="scss" scoped></style>
